import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { ChartsModule } from 'ng2-charts';
import { CommonModule, DatePipe } from '@angular/common';
import { HighchartsChartModule } from 'highcharts-angular';
import {PapaParseModule} from 'ngx-papaparse';
import { AppComponent } from './app.component';
import { RegistrationComponent } from './authentication/registration/registration.component';
import { LoginComponent } from './authentication/login/login.component';
import { MicrosoftSsoComponent } from './authentication/sso-handler/sso-handler.component';
import { AppRoutingModule } from './app.router';
import { AuthenticationService } from './authentication.service';
import { ClientService } from './services/client.service';
import { CategoryService } from './services/category.service';
import { ActivityService } from './services/activity.service';
import { TemplatesService } from './services/templates.service';
import { TemplatesMetricService } from './services/templates-metric.service';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FooterComponent } from './layouts/footer/footer.component';
import { ProjectListComponent } from './projects/list/project-list.component';
import { CreateClientComponent } from './clients/create/create-client.component';
// import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './layouts/header/header.component';
import { SidenavComponent } from './layouts/sidenav/sidenav.component';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
import { ClientListComponent } from './clients/list/client-list.component';
import { ProjectService } from './services/project.service';
import { AccountsService } from './services/accounts.service';
import { GoalService } from './services/goal.service';
import { DataService } from './services/data.service';
// import { EditProjectComponent } from './projects/edit/edit-project.component';
// import { ShowProjectComponent } from './projects/show/show-project.component';
import { CreateProjectComponent } from './projects/create/create-project.component';
import { EditClientComponent } from './clients/edit/edit-client.component';
// import { ShowErrorsComponent } from './show-errors/show-errors.component';
import { ShowErrorsModule } from './show-errors/show-errors.module';
import { ImportTimesheetComponent } from './timesheets/import-timesheet/import-timesheet.component';
import { CustomValidators } from './validators/custom-validators.validator';
import { CreateAccountComponent } from './accounts/create/create-account.component';
import { EditAccountComponent } from './accounts/edit/edit-account.component';
import { AccountListComponent } from './accounts/list/account-list.component';
import { GoalsListComponent } from './goals/list/goals-list.component';
// import { CreateGoalComponent } from './goals/create/create-goal.component';
// import { EditGoalComponent } from './goals/edit/edit-goal.component';
// import { ShowGoalComponent } from './goals/show/show-goal.component';
import { MetricService } from './services/metric.service';
import { FlashComponent } from './flash/flash.component';
import { FlashService } from './flash/flash.service';
import { AccountsMetricsComponent } from './accounts/metrics/accounts-metrics.component';
import { ShowComponent } from './accounts/show/show.component';
import { CreateTimesheetComponent } from './timesheets/create-timesheet/create-timesheet.component';
import { EditTimesheetComponent } from './timesheets/edit-timesheet/edit-timesheet.component';
import { ListTimesheetComponent } from './timesheets/list-timesheet/list-timesheet.component';
import { TimesheetService } from './services/timesheet.service';
// import { ListComponent } from './accountGoals/list/list.component';
// import { CreateComponent } from './accountGoals/create/create.component';
import { AccountGoalsService } from './services/account-goals.service';
import { AccountMetricsService } from './services/account-metrics.service';
// import { EditComponent } from './accountGoals/edit/edit.component';
import { CreateAccountMetricsComponent } from './accountMetrics/create-account-metrics/create-account-metrics.component';
import { ListAccountMetricsComponent } from './accountMetrics/list-account-metrics/list-account-metrics.component';
import { EditAccountMetricsComponent } from './accountMetrics/edit-account-metrics/edit-account-metrics.component';
import { TeamGoalsComponent } from './accountGoals/team-goals/team-goals.component';
// import { DuplicateComponent } from './accountGoals/duplicate/duplicate.component';
import { SettingsComponent } from './settings/settings.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { TabModule } from 'angular-tabs-component';
import { SettingsService } from './services/settings.service';
import { ReportComponent } from './report/report.component';
import { StatusReportComponent } from './status-report/status-report.component';
import { ErrorService } from './services/error.service';
import { CalculatorComponent } from './calculator/calculator.component';
import { SearchdataPipe } from './pipes/searchdata.pipe';
import { DataTableModule } from 'angular2-datatable';
import { AccountsearchPipe } from './pipes/accountsearch.pipe';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { PieChartComponent } from './users/pie-chart/pie-chart.component';
import { UsersService } from './users/users.service';
import { DonutChartComponent } from './users/donut-chart/donut-chart.component';
import { StackedBarChartComponent } from './users/stacked-bar-chart/stacked-bar-chart.component';
import { BarComponent } from './users/bar/bar.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ChartsComponent } from './timesheets/charts/charts.component';
import { AdminChartsComponent } from './timesheets/admin-charts/admin-charts.component';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { CategoriesListComponent } from './categories/categories-list/categories-list.component';
import { ActivitiesListComponent } from './activities/activities-list/activities-list.component';
import { RouteReuseStrategy } from '@angular/router/';
import { TeamListComponent } from './team/team-list/team-list.component';
import { ProjectComponent } from './projects/project/project.component';
import { AssignProjectsComponent } from './projects/assign-projects/assign-projects.component';
import { ShowProjectComponent } from './projects/show/show-project.component';
import { DebounceDirective } from './directives/debounce.directive';
import { ListTemplatesComponent } from './templates/list-templates/list-templates.component';
import { CreateTemplatesComponent } from './templates/create-templates/create-templates.component';
import { EditTemplatesComponent } from './templates/edit-templates/edit-templates.component';
import { ShowTemplateComponent } from './templates/show-template/show-template.component';
import { ListTemplateMetricsComponent } from './template-metrics/list-template-metrics/list-template-metrics.component';
import { CreateTemplateMetricsComponent } from './template-metrics/create-template-metrics/create-template-metrics.component';
import { EditTemplateMetricsComponent } from './template-metrics/edit-template-metrics/edit-template-metrics.component';
import { CreateCategoryComponent } from './skill-matrix/create-category/create-category.component';
import { ListCategoryComponent } from './skill-matrix/list-category/list-category.component';
import { EditCategoryComponent } from './skill-matrix/edit-category/edit-category.component';
import { SkillUpdateComponent } from './skill-matrix/skill-update/skill-update.component';
import { ListSkillComponent } from './skill-matrix/list-skill/list-skill.component';
import { EditSkillComponent } from './skill-matrix/edit-skill/edit-skill.component';
import { CreateSkillComponent } from './skill-matrix/create-skill/create-skill.component';
import { SkillService } from './skill-matrix/services/skill.service';
import { DepartmentPipe } from './skill-matrix/department.pipe';
import { CategoryPipe } from './skill-matrix/category.pipe';
import { WorkFromHomeService } from './services/work-from-home/work-from-home.service';

import { ReimbursementAddFormComponent } from './reimbursement/reimbursement-add-form/reimbursement-add-form.component';
import { ReimbursementService } from './reimbursement/reimbursement.service';
import { ReimbursementListComponent } from './reimbursement/reimbursement-list/reimbursement-list.component';
import { ReimbursementUserEditComponent } from './reimbursement/reimbursement-user-edit/reimbursement-user-edit.component';
import { ReimbursementViewItemsListComponent } from './reimbursement/reimbursement-view-items-list/reimbursement-view-items-list.component';
import { ReimbursementManagerListComponent } from './reimbursement/reimbursement-manager-list/reimbursement-manager-list.component';
import { ReimbursementManagerViewComponent } from './reimbursement/reimbursement-manager-view/reimbursement-manager-view.component';
import { ReimbursementAdminListComponent } from './reimbursement/reimbursement-admin-list/reimbursement-admin-list.component';
import { ReimbursementAdminViewComponent } from './reimbursement/reimbursement-admin-view/reimbursement-admin-view.component';
import { CategoryNamePipe } from './reimbursement/category-name.pipe';
import { StatusNamePipe } from './reimbursement/status-name.pipe';
import { ReimbursementManagerItemsListComponent } from './reimbursement/reimbursement-manager-items-list/reimbursement-manager-items-list.component';

import { VariablePayReportComponent } from './variable-pay-report/variable-pay-report.component';
import { VariablePayReportsService } from './services/variable-pay-reports.service';
import { VariablePayComponent } from './variable-pay/variable-pay.component';
import { VariablePayService } from './services/variable-pay/variable-pay.service';
// import { CustomReuseStrategy } from './CustomReuseStrategy ';
import { AdminFilterComponent } from './skill-matrix/admin-filter/admin-filter.component';
import { FilterUserDetailComponent } from './skill-matrix/filter-user-detail/filter-user-detail.component';
import { FilterSkillDetailComponent } from './skill-matrix/filter-skill-detail/filter-skill-detail.component';
import { UserDetailComponent  } from './skill-matrix/user-detail/user-detail.component';
import { AdminBlogPostComponent } from './blog/admin-blog-post/admin-blog-post.component'
import { ListBlogComponent } from './blog/list-blog/list-blog.component';
import { BlogService } from './blog/services/blog.service';
import { EditBlogComponent } from './blog/edit-blog/edit-blog.component';
import { UserListBlogComponent } from './blog/user-list-blog/user-list-blog.component';
import { EmpNameFromIdPipe } from './blog/emp-name-from-id.pipe';
import { DashboardTimesheetSummaryComponent } from './dashboard/components/dashboard-timesheet-summary/dashboard-timesheet-summary.component';
import { DashboardWfhSummaryComponent } from './dashboard/components/dashboard-wfh-summary/dashboard-wfh-summary.component';
import { DashboardService } from './services/dashboard/dashboard.service';
import { OffboardingComponent } from './offboarding/offboarding.component';
import { QuestionslistComponent } from './questions/list/list.component';
import { QuestionscreateComponent } from './questions/create/create.component';
import { QuestionseditComponent } from './questions/edit/edit.component';
import { QuestionsService } from './services/questions.service';
import { OffboardingService } from './services/offboarding.service';
import { PersonalDetailsComponent } from './offboarding/personal-details/personal-details.component';
import { ExitFormComponent } from './offboarding/exit-form/exit-form.component';
import { ExitChecklistComponent } from './offboarding/exit-checklist/exit-checklist.component';
import { PersonalDetailsService } from './services/personal-details.service';
import { ExitFormService } from './services/exit-form.service';
import { ExitChecklistService } from './services/exit-checklist.service';
import { TagsComponent } from './questions/tagsComponent/tags/tags.component';
import { TagFilterPipe } from './questions/tagsComponent/tag-filter.pipe';
import { TagService } from './questions/tagsComponent/tag.service';
import { TagComponent } from './questions/tagsComponent/tag/tag.component';
import { DynamicFormBuilderModule } from './offboarding/dynamic-form-builder/dynamic-form-builder.module';
import { PersonalDetailComponent } from './offboarding/forms-view/personal-detail/personal-detail.component';
import { ExitInterviewComponent } from './offboarding/forms-view/exit-interview/exit-interview.component';
import { ExitChecklistViewsComponent } from './offboarding/forms-view/exit-checklist-views/exit-checklist-views.component';
import { ExitChecklistViewManagerComponent } from './offboarding/forms-view/exit-checklist-view-manager/exit-checklist-view-manager.component';
import { ExitChecklistViewSysadminComponent } from './offboarding/forms-view/exit-checklist-view-sysadmin/exit-checklist-view-sysadmin.component';
import { ExitChecklistHrComponent } from './offboarding/forms-view/exit-checklist-hr/exit-checklist-hr.component';
import { SortingQuestionsComponent } from './questions/sorting-questions/sorting-questions.component';
import { AdminGuard } from './guards/admin.guard';
import { IsNotAdminGuard } from './guards/isNot-admin.guard';
import { IsNotReimbursementManagerGuard } from './guards/isNot-reimbursement_manager.guard';
import { DontHaveAccessGuard } from './guards/dont-have-access.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

@NgModule({
  declarations: [
    AppComponent,
    RegistrationComponent,
    LoginComponent,
    FooterComponent,
    ProjectListComponent,
    CreateClientComponent,
    HeaderComponent,
    SidenavComponent,
    ClientListComponent,
    // EditProjectComponent,
    // ShowProjectComponent,
    CreateProjectComponent,
    EditClientComponent,
    // ShowErrorsComponent,
    CreateAccountComponent,
    EditAccountComponent,
    AccountListComponent,
    GoalsListComponent,
    // CreateGoalComponent,
    // EditGoalComponent,
    // ShowGoalComponent,
    FlashComponent,
    AccountsMetricsComponent,
    ShowComponent,
    CreateTimesheetComponent,
    ImportTimesheetComponent,
    EditTimesheetComponent,
    ListTimesheetComponent,
    // ListComponent,
    // CreateComponent,
    // EditComponent,
    CreateAccountMetricsComponent,
    ListAccountMetricsComponent,
    EditAccountMetricsComponent,
    TeamGoalsComponent,
    // DuplicateComponent,
    SettingsComponent,
    ReportComponent,
    StatusReportComponent,
    CalculatorComponent,
    SearchdataPipe,
    AccountsearchPipe,
    DepartmentPipe,
    CategoryPipe,
    EmpNameFromIdPipe,
    PieChartComponent,
    DonutChartComponent,
    StackedBarChartComponent,
    BarComponent,
    ChartsComponent,
    AdminChartsComponent,
    CategoriesListComponent,
    ActivitiesListComponent,
    TeamListComponent,
    ProjectComponent,
    AssignProjectsComponent,
    ShowProjectComponent,
    DebounceDirective,
    ListTemplatesComponent,
    CreateTemplatesComponent,
    EditTemplatesComponent,
    ShowTemplateComponent,
    ListTemplateMetricsComponent,
    CreateTemplateMetricsComponent,
    EditTemplateMetricsComponent,
    ReimbursementAddFormComponent,
    ReimbursementListComponent,
    ReimbursementUserEditComponent,
    ReimbursementViewItemsListComponent,
    ReimbursementManagerListComponent,
    ReimbursementManagerViewComponent,
    ReimbursementAdminListComponent,
    ReimbursementAdminViewComponent,
    CategoryNamePipe,
    StatusNamePipe,
    ReimbursementManagerItemsListComponent,
    VariablePayReportComponent,
    VariablePayComponent,
    CreateCategoryComponent,
    ListCategoryComponent,
    EditCategoryComponent,
    SkillUpdateComponent,
    ListSkillComponent,
    EditSkillComponent,
    CreateSkillComponent,
    AdminFilterComponent,
    FilterUserDetailComponent,
    FilterSkillDetailComponent,
    UserDetailComponent,
    AdminBlogPostComponent,
    ListBlogComponent,
    EditBlogComponent,
    UserListBlogComponent,
    PersonalDetailsComponent,
    ExitFormComponent,
    ExitChecklistComponent,
    QuestionslistComponent,
    QuestionscreateComponent,
    QuestionseditComponent,
    OffboardingComponent,
    TagsComponent,
    TagFilterPipe,
    TagComponent,
    PersonalDetailComponent,
    ExitInterviewComponent,
    ExitChecklistViewsComponent,
    ExitChecklistViewManagerComponent,
    ExitChecklistViewSysadminComponent,
    ExitChecklistHrComponent,
    SortingQuestionsComponent,
    PageNotFoundComponent,
    MicrosoftSsoComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    PapaParseModule,
    HighchartsChartModule,
    ChartsModule,
    TabModule,
    DynamicFormBuilderModule,
    FlashMessagesModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    ShowErrorsModule,
    MultiselectDropdownModule, 
    DataTableModule,
    NgxPaginationModule,
    NgxMyDatePickerModule.forRoot(),
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    DebounceDirective,
    DepartmentPipe,
    CategoryPipe,
    EmpNameFromIdPipe
  ],
  providers: [
    AuthenticationService,
    ClientService,
    CategoryService,
    ActivityService,
    ProjectService,
    AccountsService,
    GoalService,
    AuthGuard,
    MetricService,
    RoleGuard,
    AdminGuard,
    IsNotAdminGuard,
    DontHaveAccessGuard,
    IsNotReimbursementManagerGuard,
    FlashService,
    TimesheetService,
    DatePipe,
    AccountGoalsService,
    AccountMetricsService,
    SettingsService,
    ErrorService,
    UsersService,
    DataService,
    TemplatesService,
    TemplatesMetricService,
    WorkFromHomeService,
    ReimbursementService,
    VariablePayReportsService,
    VariablePayService,
    SkillService,
    BlogService,
    WorkFromHomeService,
    DashboardService,
    QuestionsService,
    OffboardingService,
    PersonalDetailsService,
    ExitFormService,
    ExitChecklistService,
    TagService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/app.module.ts